import React, { useState, useEffect } from "react";
import { useRedirect } from "react-admin";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { Link } from "react-router-dom";
import AppBar from "../../header/AuthenticationPageHeader";
import Button from "@material-ui/core/Button";
import Input from "@material-ui/core/Input";
import AppProvider from "./../../bootstrap/index";
import LinkedinLogo from "../../../images/linkedin.png";
import GoogleLogo from "../../../images/google.png";
import { connect } from "react-redux";

import {
  userLogin,
  Notification,
  useLogin,
  useNotify,
  useAuthProvider,
} from "react-admin";
import GoogleLogin from "react-google-login";
import { useRouteState } from "./../../../Utils/hooks";

const useStyles = makeStyles((theme) => ({
  "@global": {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  paper: {
    // marginTop: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: 10,
    width: 300,
    height: 60,
    // margin: theme.spacing(1),
    backgroundColor: "white",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    // marginTop: theme.spacing(5),
  },
  label: {
    width: "20%",
  },
  button: {
    width: "100%",
    margin: "0 auto",
    marginTop: "6%",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  Input: {
    marginTop: "8%",
    backgroundColor: "#ffffff",
  },
  coverBackgroundContainer: {
    backgroundColor: "#F7F8F9",
    height: "100vh",
    backgroundSize: "cover",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    paddingLeft: "4%",
    paddingRight: "4%",
    paddingTop: "50px",
    // paddingBottom:"20px"
  },
  buttonProgress: {
    color: "green[500]",
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

function SignIn(props) {
  const redirect = useRedirect();
  const classes = useStyles();
  const authProvider = useAuthProvider();
  const location = useRouteState();

  const [password, setPassword] = useState("");
  const [username, setUsername] = useState("");

  const [showPassword] = useState(false);
  const notify = useNotify();

  useEffect(() => {
    if (location.query && location.query.state === "linkedinInLogin") {
      authProvider.loginLinkedIn({
        code: location.query.code,
        redirect,
        notify,
      });
    }
  }, [authProvider, location, redirect, notify]);

  const [loading, setLoading] = useState(false);
  const [hasError] = useState(false);
  const login = useLogin();
  // const redirect=useRedirect();

  // const handleChange = event => {
  //   setShowPasswod(!showPassword)
  // };

  const handleChange1 = (event) => {
    setPassword(event.target.value);
  };
  
  const submit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await login({
        username: username,
        password: password,
        redirect: redirect,
        notify: notify,
      });
      notify("Logged in successfully");
      // redirect('/paymentdetails')
    } catch (e) {
      notify(e.message, "warning");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={classes.coverBackgroundContainer}>
      <AppProvider>
        <AppBar />

        <Container
          component="main"
          maxWidth="xs"
          style={{ background: "#ffffff" }}
        >
          <div className={classes.paper}>
            {/* <Avatar className={classes.avatar} > 
        <Link to="/">
          <img src={Logo} alt={"123Mentor"} />
        </Link>
        </Avatar> */}
            <Typography
              component="h6"
              variant="h6"
              style={{ paddingTop: "4%" }}
            >
              Login
            </Typography>
            <form className={classes.form} onSubmit={submit}>
              {/* <FormControl className={[classes.margin, classes.textField1].join(' ')}> */}
              <Input
                className={classes.Input}
                autoFocus
                id="username"
                name="username"
                //  margin="normal"
                value={username}
                required
                label="Email Address"
                placeholder="Enter Email"
                type="text"
                //  type="username"
                //  autoComplete="username"
                variant="standard"
                onChange={(e) => setUsername(e.target.value)}
                fullWidth
              />
              {/* </FormControl> */}
              {/* <FormControl className={classes.textField1.join(' ')}> */}
              <Input
                className={classes.Input}
                id="password"
                name="password"
                required
                label="Password"
                placeholder="Enter Password"
                //  label="Password"
                type={showPassword ? "text" : "password"}
                variant="standard"
                fullWidth
                onChange={handleChange1}
                value={password}
              />
              {/* </FormControl> */}
              <Grid container>
                <Grid
                  item
                  xs={12}
                  style={{ textAlign: "right", paddingTop: "8%" }}
                >
                  <Link
                    to="/forgotpassword"
                    style={{ textDecoration: "none", color: "#000000" }}
                  >
                    Forgot password?
                  </Link>
                </Grid>
              </Grid>

              {/* <SignInButton type="submit" buttonname="Sign In"/> */}
              {/* <Button
                type="submit"
                className={classes.button}
                variant="contained"
                color="primary"
              // disabled= {hasError ? !hasError : loading}
              >
                
            </Button> */}
              <Button
                type="submit"
                className={classes.button}
                disabled={hasError ? !hasError : loading}
                variant="contained"
                color="primary"
              >
                {!hasError && loading && (
                  <CircularProgress
                    size={24}
                    className={classes.buttonProgress}
                  />
                )}
                Sign In
              </Button>

              <Grid container>
                <Grid
                  item
                  xs={12}
                  style={{ textAlign: "center", paddingTop: "6%" }}
                >
                  <Typography
                    variant="subtitle2"
                    component="h6"
                    style={{ textDecoration: "none", color: "#000000" }}
                  >
                    or Login using
                  </Typography>
                </Grid>
              </Grid>

              <Grid container>
                <Grid
                  item
                  xs={4}
                  style={{
                    textAlign: "right",
                    paddingTop: "8%",
                    paddingRight: "10px",
                  }}
                >
                  <img
                    src={GoogleLogo}
                    alt={"123Mentor"}
                    style={{ width: "35px", paddingRight: "9%" }}
                  />
                </Grid>
                <Grid
                  item
                  xs={2}
                  style={{
                    textAlign: "Left",
                    paddingTop: "8%",
                    marginLeft: "-15px",
                  }}
                >
                  <GoogleLogin
                    clientId="208946399161-7v80irs0uea2pi33rlo2p4onb717j31i.apps.googleusercontent.com"
                    render={(renderProps) => (
                      <Link
                        onClick={renderProps.onClick}
                        style={{ textDecoration: "none", color: "#000000" }}
                      >
                        Google
                      </Link>
                    )}
                    buttonText="Login"
                    onSuccess={(payload) =>
                      authProvider.loginGoogle({ payload, redirect, notify })
                    }
                    onFailure={(e) => {
                      console.error(e);
                      notify("Unable to login to google");
                    }}
                    cookiePolicy={"single_host_origin"}
                  />
                </Grid>

                <Grid
                  item
                  xs={2}
                  style={{
                    textAlign: "right",
                    paddingTop: "8%",
                    paddingLeft: "10px",
                  }}
                >
                  <img
                    src={LinkedinLogo}
                    alt={"123Mentor"}
                    style={{ width: "23px" }}
                  />
                </Grid>
                <Grid
                  item
                  xs={4}
                  style={{ textAlign: "Left", paddingTop: "8%" }}
                >
                  <a
                    href={`https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${process.env.REACT_APP_LINKEDIN_CLIENT_ID}&redirect_uri=${window.location.href}&scope=r_emailaddress%20r_liteprofile&state=linkedinInLogin`}
                    style={{
                      textDecoration: "none",
                      color: "#000000",
                      paddingLeft: "5%",
                    }}
                  >
                    LinkedIn
                  </a>
                </Grid>
              </Grid>
              <Grid container>
                <Grid
                  item
                  xs={12}
                  style={{ textAlign: "center", marginTop: "10%" }}
                >
                  <Link
                    to="/v2/signup"
                    style={{ textDecoration: "none", color: "#000000" }}
                  >
                    New user? Create new account
                  </Link>
                </Grid>
              </Grid>
            </form>
          </div>
          <Box mt={8}></Box>
        </Container>
      </AppProvider>
      <Notification />
    </div>
  );
}

// export default SignIn;
export default connect(undefined, { userLogin })(SignIn);
